import React, {Component} from 'react';
import WalletIapRechargePage from "./AppPage/WalletIapRechargePage";
import InviteNewUserPage from "./AppPage/InviteNewUser/InviteNewUserPage";
import InviteNewAcceptPage from "./AppPage/InviteNewUser/InviteNewAcceptPage"
import InviteNewSuccessPage from "./AppPage/InviteNewUser/InviteNewSuccessPage"
import H5Debug from "../components/activity/H5Debug";


class AppPage extends Component {
    renderContent() {
        const {type} = this.props.params;
        let content = null;
        switch (type) {
            case 'iap_recharge':
                content = <WalletIapRechargePage />;
                break;
            case 'invite_new':
                content = <InviteNewUserPage />;
                break;
            case 'invite_accept':
                content = <InviteNewAcceptPage />;
                break;
            case 'invite_success':
                content = <InviteNewSuccessPage />;
                break;
            default:
                content = <H5Debug/>
                break;
        }
        return content;
    }
    render() {
        return (
            <div>
                {this.renderContent()}
            </div>
        )
    }
}


export default AppPage


// WEBPACK FOOTER //
// ./src/pages/AppPage.js